import React, { FC } from "react";

export type ColumnProps = {
  readonly size?: number;
};

export const Column: FC<ColumnProps> = ({ children, size }) => (
  <div className={"column" + (size ? " size-" + size : "")}>{children}</div>
);
